function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
import { jsx as _jsx } from "react/jsx-runtime";
/*
 * @Author: Antes
 * @Email: tangzhlyd@gmail.com
 * @Date: 2021/12/14 14:25
 * @Description: 用于设置每个路由 的 name & code & 按钮权限
 */ import { createContext, useContext } from "react";
const RouteContext = /*#__PURE__*/ createContext({});
export const Provider = RouteContext.Provider;
export const useRoute = ()=>{
    // const routeContext = React.useContext(RouteContext)
    return useContext(RouteContext);
};
export function RouteProvider(param) {
    let { children, value } = param;
    return /*#__PURE__*/ _jsx(Provider, {
        value: value,
        children: children
    });
}
var _tagsAction = /*#__PURE__*/ new WeakMap();
class TagsActive {
    getActiveRoute() {
        return _class_private_field_get(this, _tagsAction);
    }
    setActiveRoute(tagsAction) {
        _class_private_field_set(this, _tagsAction, tagsAction);
    }
    constructor(){
        _class_private_field_init(this, _tagsAction, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _tagsAction, null);
    }
}
export const activeRoute = new TagsActive();
